import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ResponseResult } from '@app/auth/model';
import { environment } from '@environments/environment';
import { StudentCoursePreReg } from '@app/admin/model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudentCoursePreRegService {
  private route: string = "admin";
  private controller: string = "studentCoursePreReg";
  private endpointPrefix: string;

  constructor(private http: HttpClient) {
    this.endpointPrefix = `${environment.urlAPI}/${this.route}/${this.controller}`;
  }

  getall(): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/get`);
  }

  getById(id: string): any {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/getById`, {params: params});
  }

  getByUserId(userId: string): any {
    let params = new HttpParams();
    params = params.append('userId', userId);
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/getByUserId`, {params: params});
  }

  getByContactBySiteId(contactBySiteId: string): any {
    let params = new HttpParams();
    params = params.append('contactBySiteId', contactBySiteId);
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/getByContactBySiteId`, {params: params});
  }

  save(model: StudentCoursePreReg, editing: boolean = false): any {
    if (editing) { //update
      return this.http.put<ResponseResult>(`${this.endpointPrefix}/update`, model);
    } else { //new
      return this.http.post<ResponseResult>(`${this.endpointPrefix}/add`, model);
    }
  }

  remove(id: any): Observable<any> {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.delete<ResponseResult>(`${this.endpointPrefix}/remove`, {params: params});
  }
}
